import React from 'react';

const Icon = ({ size = '17', fill = 'url(#prefix_dxc-svg-to-react_b)', ...other }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 17 17" fill="none" {...other}>
            <g filter="url(#a)">
                <path d="M7.01.13h2.15v6.925h6.894v2.15H9.16v6.925H7.01V9.205H.116v-2.15H7.01V.13Z" fill="url(#b)" />
            </g>
            <defs>
                <linearGradient id="b" x1="-1.368" y1="-29.07" x2="34.631" y2="-24.018" gradientUnits="userSpaceOnUse">
                    <stop offset="0.226" stopColor="#FFF6E0" />

                    <stop offset="0.663" stopColor="#8E6B40" />
                </linearGradient>
                <filter id="a" x="-0.183" y="0.13" width="16.236" height="16.3" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />

                    <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />

                    <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />

                    <feOffset dx="-0.3" dy="0.3" />

                    <feGaussianBlur stdDeviation="0.9" />

                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />

                    <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.59 0" />

                    <feBlend in2="shape" result="effect1_innerShadow_5306_20641" />
                </filter>
            </defs>
        </svg>
    );
};
export default React.memo(Icon);
